<script>
import { scrollTo as scroll } from '@router/smoothScroll'

export default {
  data() {
    return {
      message: null,
    }
  },
  methods: {
    async setErrorMessage(error, { scrollTo = 'Message-scroll' } = {}) {
      if (error.ignore) error.ignore()

      if (error.errors && error.errors.length && error.errors[0] !== null) {
        this.danger(error.errors[0])
      } else {
        this.danger(typeof error === 'string' ? error : error.message)
      }

      // needs next tick to for ref to be created, since it can be in v-if
      await this.$nextTick()

      if (this.$refs[scrollTo]) scroll(this.$refs[scrollTo].$el)
    },
    setMessage({ theme = 'neutral', text = '' } = {}) {
      this.message = { theme, text }
    },
    clearMessage() {
      this.message = null
    },
    success(text) {
      this.setMessage({ theme: 'success', text })
    },
    warning(text) {
      this.setMessage({ theme: 'warning', text })
    },
    danger(text) {
      this.setMessage({ theme: 'danger', text })
    },
  },
}
</script>
